import NotFoundError from 'shared/errors/NotFoundError'

export default (valid, id) => {
  if (!valid) {
    throw new NotFoundError(`Invalid id "${id}"`)
  }
}
